var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("basic-container", [
    _c(
      "div",
      { staticClass: "avue-crud" },
      [
        _c(
          "el-form",
          { attrs: { inline: true } },
          [
            _c(
              "el-form-item",
              { attrs: { label: "菜单名称", prop: "menuName" } },
              [
                _c("el-input", {
                  attrs: {
                    clearable: "",
                    placeholder: "请输入菜单名称",
                    size: "small",
                  },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.getList.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.queryParams.menuName,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "menuName", $$v)
                    },
                    expression: "queryParams.menuName",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    attrs: { icon: "el-icon-search", type: "primary" },
                    on: { click: _vm.getList },
                  },
                  [_vm._v("搜索")]
                ),
                _vm.permissions.sys_menu_add
                  ? _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-plus", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.addOrUpdateHandle(false)
                          },
                        },
                      },
                      [_vm._v("\n          添加\n        ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: {
              data: _vm.menuList,
              "tree-props": {
                children: "children",
                hasChildren: "hasChildrens",
              },
              border: "",
              "row-key": "id",
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": true,
                label: "页面名称",
                prop: "name",
                width: "180",
              },
            }),
            _c("el-table-column", {
              attrs: { label: "排序", prop: "sortOrder", width: "60" },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": true,
                label: "组件路径",
                prop: "path",
              },
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                label: "类型",
                prop: "menuType",
                width: "80",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.menuType === "0"
                        ? _c("el-tag", { attrs: { type: "success" } }, [
                            _vm._v("页面"),
                          ])
                        : _vm._e(),
                      scope.row.menuType === "1"
                        ? _c("el-tag", { attrs: { type: "info" } }, [
                            _vm._v("按钮"),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                label: "显示状态",
                prop: "visible",
                width: "80",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.visible === "1"
                        ? _c("el-tag", { attrs: { type: "success" } }, [
                            _vm._v("显示"),
                          ])
                        : _vm._e(),
                      scope.row.visible === "0"
                        ? _c("el-tag", { attrs: { type: "info" } }, [
                            _vm._v("隐藏"),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": true,
                label: "权限标识",
                prop: "permission",
              },
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                "class-name": "small-padding fixed-width",
                label: "操作",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm.permissions.app_appmenu_add
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-plus",
                                size: "small",
                                type: "text",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addOrUpdateHandle(
                                    false,
                                    scope.row.id
                                  )
                                },
                              },
                            },
                            [_vm._v("新增\n          ")]
                          )
                        : _vm._e(),
                      _vm.permissions.app_appmenu_edit
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-edit",
                                size: "small",
                                type: "text",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addOrUpdateHandle(
                                    true,
                                    scope.row.id
                                  )
                                },
                              },
                            },
                            [_vm._v("修改\n          ")]
                          )
                        : _vm._e(),
                      _vm.permissions.app_appmenu_del
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-delete",
                                size: "small",
                                type: "text",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDelete(scope.row)
                                },
                              },
                            },
                            [_vm._v("删除\n          ")]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm.addOrUpdateVisible
          ? _c("table-form", {
              ref: "addOrUpdate",
              on: { refreshDataList: _vm.getList },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }